import { IPhoneNumber } from "../../models/phone-number.model";
import {Component, Input, OnInit} from "@angular/core";
import {CountryInfo, ICountryInfo} from "../../models/phone-number-flag.model";

@Component({
  selector: 'app-phone-number',
  standalone: true,
  imports: [],
  templateUrl: './country-code.component.html',
  styleUrls: ['./country-code.component.scss']
})
export class CountryCodeComponent implements OnInit {
  @Input() phoneNumber: IPhoneNumber | undefined;
  countryInfo: ICountryInfo | undefined;

  ngOnInit(): void {
    this.countryInfo = CountryInfo.getCountryInfo(this.phoneNumber);
  }
}
